export const CuponTypes = {
  Percentage: "percentage",
  Price: "price",
};
